import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "./ListDetailBackBar.scss";

export const ListDetailBackBar = (props: ListDetailBackBarProps) => (
  <div className="list-detail-back-bar">
    <button
      type="button"
      className="btn btn-link list-detail-back-button"
      onClick={props.onBack}
    >
      <ArrowBackIcon className="me-1" />
      {props.label}
    </button>
  </div>
);

interface ListDetailBackBarProps {
  label: string;
  onBack: () => void;
}
